<template>
    <div class="w-100 mx-auto rounded my-2 my-md-5">
        <div class="container">
            <div class="row text-center">
                <div class="col-4">
                    <div class="anime">
                        <img src="@/assets/vendor-feat-1.svg" alt="learn" class="img-fluid mt-4">
                    </div>
                    <p class="mt-3 fw-semibold open600">Increase your
                        Revenue</p>
                </div>
                <div class="col-4">
                    <div class="anime">
                        <img src="@/assets/vendor-feat-2.svg" alt="grow" class="img-fluid mt-4">
                    </div>
                    <p class="mt-3 fw-semibold open600">Easy to customize
                        your orders</p>
                </div>
                <div class="col-4">
                    <div class="anime">
                        <img src="@/assets/vendor-feat-3.svg" alt="connect" class="img-fluid mt-4">
                    </div>
                    <p class="mt-3 fw-semibold open600">Boost efficiency and
                        orders</p>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.anime {
    transition: .3s transform;
}

.anime:hover {
    transform: scale(1.1);
}
</style>